 
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    private injector: Injector, // Avoids cyclic dependency
    private ngZone: NgZone // Runs Snackbar in Angular zone
  ) {}

  handleError(error: any): void {
    console.error('Global Error:', error); // Log error in the console

    let message = '';
    if (error === null || error === undefined) {
      message = String(error); // 'null' or 'undefined'
    } else if (error.message) {
      message = error.message;
      // If internal error message use it
      if (error.error?.message) {
        message += error.error.message;
      }
    } else {
      message = error.toString();
    }

    this.showErrorMessage(message);
  }

  showErrorMessage(message: string): void {
    // Lazy load MatSnackBar to prevent circular dependencies
    const snackBar = this.injector.get(MatSnackBar);

    // Run inside Angular zone to update UI
    this.ngZone.run(() => {
      snackBar.open(message, 'Dismiss', {
        duration: 10000,
        panelClass: ['error-snackbar'], // Optional custom styling
      });
    });
  }
}
